import { render, staticRenderFns } from "./TypeIsFree.vue?vue&type=template&id=ddd9938c&"
import script from "./TypeIsFree.vue?vue&type=script&lang=js&"
export * from "./TypeIsFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports